import { Component, Input } from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector   : 'wor-video-viewer',
  template: require('./video-viewer.component.html')
})
export class VideoViewerComponent {
  @Input() src : string;

  constructor (
    public activeModal: NgbActiveModal
  ) {}
}
